import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/img/logo-small.png'
import _imports_1 from '../../../public/images/img/icons/instagram.svg'
import _imports_2 from '../../../public/images/img/icons/telegram.svg'
import _imports_3 from '../../../public/images/img/icons/in.svg'


const _withScopeId = n => (_pushScopeId("data-v-25f6acbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__block" }
const _hoisted_4 = { class: "footer__left-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "footer__logo"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_6 = { class: "footer__copyright" }
const _hoisted_7 = { class: "footer__left-bottom" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<a target=\"_blank\" href=\"https://instagram.com/masons_traffic?igshid=YmM0MjE2YWMzOA==\" class=\"footer__icon\" data-v-25f6acbe><img src=\"" + _imports_1 + "\" alt=\"instagram\" data-v-25f6acbe></a><a target=\"_blank\" href=\"https://t.me/masoninfo\" class=\"footer__icon\" data-v-25f6acbe><img src=\"" + _imports_2 + "\" alt=\"telegram\" data-v-25f6acbe></a><a target=\"_blank\" href=\"https://www.linkedin.com/company/masons-traffic\" class=\"footer__icon\" data-v-25f6acbe><img src=\"" + _imports_3 + "\" alt=\"linkedin\" data-v-25f6acbe></a>", 3)
const _hoisted_11 = { class: "footer__wrap" }
const _hoisted_12 = { class: "footer__menu-nav" }
const _hoisted_13 = { href: "/#faq" }
const _hoisted_14 = { class: "footer__menu-contact" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "mailto:support@masons.partners"
  }, "support@masons.partners")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://t.me/masonschat"
  }, "@mtchat")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, "© " + _toDisplayString(_ctx.$t('footer.copy')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.reserv')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.social')), 1),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('footer.nav')), 1),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('footer.navLinks.2.label')), 1)
          ])
        ]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('footer.contact')), 1),
          _hoisted_15,
          _hoisted_16
        ])
      ])
    ])
  ]))
}